import { render } from "./ListPayments.vue?vue&type=template&id=82f3dbd8&ts=true"
import script from "./ListPayments.vue?vue&type=script&lang=ts"
export * from "./ListPayments.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/cibweb-v2-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__